import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    notifications: [],
    showNotificationPanel: false,
  },
  reducers: {
    setNotificationPanel(state, action) {
      state.showNotificationPanel = action.payload;
    },
    setNotifications(state, action) {
      state.notifications = action.payload.sort((a, b) =>
        b.createdAt.localeCompare(a.createdAt)
      );
    },
    dismissNotification(state, action) {
      let indexOfItem = state.notifications.findIndex(
        (x) => x.id === action.payload
      );
      state.notifications.splice(indexOfItem, 1);
    },
    markNotificationsAsRead(state) {
      state.notifications.forEach((notif) => {
        if (notif.read === false) {
          notif.read = true;
        }
      });
    },
  },
});

export const notificationActions = notificationSlice.actions;
export default notificationSlice.reducer;